/**
 * Drop target for month-view cells and agenda-view day headers.
 *
 * Just a useDroppable wrapper — children are owned by the caller so the
 * day-cell layout (events list, day number, etc.) is unaffected. The
 * caller reads `isOver` via the hook-less render-prop pattern so the
 * parent can style only the parts it wants highlighted.
 */

import React from 'react'
import { useDroppable } from '@dnd-kit/core'
import { format } from 'date-fns'

export const DAY_DROP_TYPE = 'day-cell'

export interface DayDropData {
  kind: typeof DAY_DROP_TYPE
  dateIso: string
}

interface DayDropCellProps {
  date: Date
  children: (ctx: { isOver: boolean; setNodeRef: (el: HTMLElement | null) => void }) => React.ReactNode
}

export const DayDropCell: React.FC<DayDropCellProps> = ({ date, children }) => {
  const dateIso = format(date, 'yyyy-MM-dd')
  const { setNodeRef, isOver } = useDroppable({
    id: `${DAY_DROP_TYPE}:${dateIso}`,
    data: { kind: DAY_DROP_TYPE, dateIso } satisfies DayDropData,
  })
  return <>{children({ isOver, setNodeRef })}</>
}

export default DayDropCell
